/*
 * Please, follow the pattern below to create a new feature flag:
 *
 * # PREFIX_
 * There are 3 recommended prefixes (which follows unleash link https://docs.getunleash.io/reference/feature-toggle-types#feature-flag-types):
 * - RELEASE: for temporary feature flags that might be removed after 40 days*
 * - OPERATIONAL: for temporary feature flags that might be removed after 15 days*
 * - EXPERIMENT: for temporary feature flags that might be removed after 40 days*
 * - FOREVER: permanent feature flags
 *
 * * The days are alerts to remove the feature flag, so it does not mean that the feature flag will be removed exactly after 15 or 40 days.
 *
 * # TEAM_NAME
 * Add the team name that is responsible for the feature flag (the creator)
 *
 * anatomy: PREFIX_TEAM_NAME_FEATURE_FLAG_NAME
 *
 * examples:
 * - EXPERIMENT_CATALOG_SOMETHING_NICE
 * - FOREVER_CHECKOUT_ANOTHER_NICE_THING
 *
 * more info on the thread: https://juntossomosmais.slack.com/archives/CLP6B13J5/p1727878190374059
 */

export const FEATURE_FLAG = {
  RELEASE_ONBOARDING_GET_CNPJ_V2: 'enableAdminGetUnfoldedCnpjV2', // https://juntossomosmais.monday.com/boards/8068795447/pulses/8835687587
  RELEASE_LV_ADMIN_AUTH0_LOGIN: 'enableLVAdminAuth0Login', // https://juntossomosmais.monday.com/boards/8068795447/pulses/18069796038
  RELEASE_LV_ADMIN_AUTH0_IMPERSONATION: 'enableLVAdminAuth0Impersonation', // https://juntossomosmais.monday.com/boards/8068795447/pulses/18090065569
}
